/**
 * Convert data before send request
 * @returns {*}
 * @param form
 */
// import { hasOwnProperty } from "luxon/src/impl/util";

let query = function buildQuery(form) {
  let params = {};
  for (let index in form) {
    let key = form[index].name;
    params[key] = form[index].value;
  }

  return params;
};

function convertDate(date, operator) {
  // let dateString =
  //   date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
  let time = operator === "lt" || operator === "le" ? "23:59:59" : "00:00:00";

  return date + " " + time;
}

let formAdd = function buildFormAdd(items) {
  let formData = {};
  for (let index in items) {
    // if (items[index].name === 'img_file'){
    //   formData[items[index].name] = this.$refs.file.files[0];
    //   continue;
    // }
    formData[items[index].name] = items[index].value;
  }
  return formData;
};

let buildFormData = function buildFormData(items) {
  let formData = new FormData();
  for (let key in items) {
    if (items.hasOwnProperty(key) && items[key] !== null) {
      formData.append(key, items[key]);
    }
  }
  return formData;
};

export default {
  buildQuery: query,
  buildFormAdd: formAdd,
  buildFormData: buildFormData
};
